import { NewAgendaComponent } from 'app/home/sidebar/newAgenda/new_agenda';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';

@Component({
	selector: 'app-welcome',
	templateUrl: './welcome.html',
	styleUrls: ['./../home.css']
})
export class WelcomeComponent {

	constructor(private modalService: NgbModal) { }

	addAgenda() {
		const modalRef = this.modalService.open(NewAgendaComponent);
	}

}




// WEBPACK FOOTER //
// ./src/app/home/welcome/welcome.ts